<script setup lang="ts">
import {ref, reactive} from "vue";
import consumer from '@/channels/consumer';
import {ImportError} from "@/lib/datasources/ImportError";
import ProgressBar from "./ProgressBar.vue";
import ErrorMessage from "./ErrorMessage.vue";
import Beat from "@/lib/Beat.vue";


const importErrors = reactive([]);
const statusMessages = reactive([]);
const body = ref("");

const count = ref(0);
const length = ref(1);
const errors = ref(0);
const beat = ref(false);
const beatKey = ref(0);
consumer.subscriptions.create({channel: "DatasourceChannel", room: 'import'}, {
  connected() {
    console.log("connected");
    document.querySelectorAll('.job-button').forEach(e => e.disabled = false);
  },
  received(response) {
    switch (response.status) {
      case "start":
        count.value = response.progress.count;
        length.value = response.progress.length;
        body.value = response.body;
        break;
      case "update":
        count.value = response.progress.count;
        length.value = response.progress.length;
        body.value = response.body;
        break;
      case "finish":
        count.value = response.progress.count;
        length.value = response.progress.length;
        body.value = response.body;
        break;
      case "error":
        errors.value++;
        importErrors.push(new ImportError(response.index, response.datasource, response.error));
        break;
      case "beat":
        beat.value = false;
        beatKey.value++;
        beat.value = true;
        break;
      default:
        break;
    }
  },
});
</script>
<template>
  <Beat v-if="beat" :key="beatKey"/>
  <p>{{ body }}</p>
  <div v-if="length != 1">
    <ProgressBar v-if="length != 1" :count="count" :length="length"/>
    <p>Errors: {{ errors }}</p>
    <div class="accordion" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#import-error-accordion" aria-expanded="true"
                  aria-controls="import-error-accordion">
            Error Messages
          </button>
        </h2>
        <div id="import-error-accordion" class="accordion-collapse collapse show">
          <ErrorMessage v-for="importError in importErrors" :key="importError.index" :index="importError.index"
                        :datasource="importError.datasource" :error="importError.error"/>
        </div>
      </div>
    </div>
  </div>
</template>